import { Box } from '@chakra-ui/react'

import { Loading } from '@/components/Loading'
import { Steps } from '@/components/Steps/Steps'
import { Step1 } from '@/containers/steps/vehicle/DailyPov'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { SidebarProvider } from '@/context/SidebarContext'
import { StepsProvider } from '@/context/StepsContext'
import { WithAuth } from '@/hoc/WithAuth'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { Sidebar } from '@/layouts/components/Sidebar'
import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'

const Step1PageComponent = () => {
  const { insuranceParams: ip, insuranceParamsId: paramsId, isLoadingData } = useInsuranceParams()
  const insuranceParams = ip as InsuranceParamsDto

  return (
    <StepsProvider currentStepId={1}>
      <SidebarProvider>
        <PageWrapper
          steps={<Steps />}
          sidebar={<Sidebar />}
        >
          <Box sx={{ pt: { base: 0, md: 8 } }}>
            {isLoadingData && <Loading large={true} />}

            {(!paramsId || insuranceParams) && !isLoadingData &&
              <Step1 data={insuranceParams} />
            }
          </Box>
        </PageWrapper>
      </SidebarProvider>
    </StepsProvider>
  )
}

export const Step1Page = WithAuth(Step1PageComponent)